export default __webpack_public_path__ + "Poppins-Regular.ttf?1c701c9a6b587802e3d0211e89c52f4a";